// extracted by mini-css-extract-plugin
export var close = "style-module--close--2d38d";
export var modal = "style-module--modal--7a045";